<template>
  <div>
    <!-- <b-overlay :show="!LoaderStatus" rounded="sm"> -->
    <div class="addeval-content-container">
      <!-- Add Name -->
      <b-row
        ><b-col>
          <div class="topDiv">
            <label class="label-txt-form"
              >Name<span class="asterik">*</span></label
            >
            <b-form-input
              class="filter-input"
              id="input-1"
              type="text"
              v-model.trim="$v.panel.name.$model"
              v-on:keyup.enter="addPanel()"
              placeholder="Enter name"
              :class="{ error: $v.panel.name.$error }"
            >
            </b-form-input>
            <!-- Validations for Name -->
            <div
              v-if="$v.panel.name.$dirty && !$v.panel.name.required"
              class="errortxt position-absolute"
            >
              Required
            </div>
            <div
              v-else-if="!$v.panel.name.maxLength && $v.panel.name.required"
              class="errortxt position-absolute"
            >
              Should not exceed 128 characters
            </div>
            <div
              v-else-if="!$v.panel.name.alpha && $v.panel.name.required"
              class="errortxt position-absolute"
            >
              Please Enter a Valid Name
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- Add Mail -->
      <b-row
        ><b-col>
          <div class="topDiv mt-3">
            <label class="label-txt-form"
              >Email ID<span class="asterik">*</span></label
            >
            <b-form-input
              class="filter-input"
              id="input-1"
              type="text"
              placeholder="Enter email"
              @keyup="convertToLowerCase"
              v-model.trim="$v.panel.email.$model"
              :class="{ error: $v.panel.email.$error }"
            >
            </b-form-input>
            <div
              v-if="$v.panel.email.$dirty && !$v.panel.email.required"
              class="errortxt position-absolute"
            >
              Required
            </div>
            <div
              v-else-if="!$v.panel.email.maxLength"
              class="errortxt position-absolute"
            >
              Should not exceed 64 characters
            </div>
            <div
              v-else-if="!$v.panel.email.alpha"
              class="errortxt position-absolute"
            >
              Email is invalid
            </div>

            <!-- Validations for Mail -->
          </div>
        </b-col>
      </b-row>
      <!-- Add Contact Number -->
      <b-row
        ><b-col>
          <div class="topDiv mt-3">
            <label class="label-txt-form"
              >Contact Number<span class="asterik">*</span></label
            >
            <b-form-input
              class="filter-input"
              id="input-1"
              type="text"
              @keypress="NumbersOnly"
              placeholder="Enter contact number"
              v-model.trim="$v.panel.phoneNumber.$model"
              :class="{ error: $v.panel.phoneNumber.$error }"
              maxlength="10"
            >
            </b-form-input>
            <!-- Validations for Contact Number -->
            <div
              v-if="
                $v.panel.phoneNumber.$dirty && !$v.panel.phoneNumber.required
              "
              class="errortxt position-absolute"
            >
              Required
            </div>
            <div
              v-else-if="
                !phoneValid ||
                ($v.panel.phoneNumber.required && !$v.panel.phoneNumber.alpha)
              "
              class="errortxt position-absolute"
            >
              Enter valid number
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- Add Area of Expertise Tags -->
      <b-row
        ><b-col>
          <div
            class="topDiv mt-3 aoeskl-field panellist-tags"
            @click="expertiseFunction()"
            ref="exp"
            v-closable="{
              exclude: ['exp', 'expdropdown'],
              handler: 'hideexpertiseoptions',
            }"
          >
            <label class="label-txt-form"
              >Area Of Expertise<span class="asterik">*</span></label
            >
            <b-form-tags
              remove-on-delete
              @input="expertiseFunction()"
              class="text-truncate filter-input-pan w-100"
              :class="{
                'error reqd_add_1': $v.aoeoptiontags.$error,
                reqd_add_2: !$v.aoeoptiontags.$error,
                tagsinputField:
                  $v.aoeoptiontags.length > 0 && !$v.aoeoptiontags.$error,
              }"
              :tag-validator="tagValidatoraoe"
              invalid-tag-text="Duplicate tag(s)"
              placeholder="Enter area of expertise"
              v-model="$v.aoeoptiontags.$model"
            ></b-form-tags>
            <div>
              <span class="hint-txt">Press "Enter" to add expertise</span>
            </div>
            <!-- Validations for Area of Expertise -->
            <div
              v-if="$v.aoeoptiontags.$dirty && !$v.aoeoptiontags.required"
              class="errortxt position-absolute mt-3"
            >
              Required
            </div>
          </div>
          <!-- Dropdown for Area of Expertise Tags-->
          <div v-if="aoe == true" class="qb-filter-modal-sug" ref="expdropdown">
            <div class="relativeclass aoeinput opt-check">
              <div class="aoesearchicon-pos">
                <img
                  src="../../assets/img/accesscontrol/inputsearch.svg"
                  alt=""
                />
              </div>
              <b-form-input
                class="inputField options"
                type="search"
                placeholder="Search"
                v-model.trim="searchexp"
                debounce="500"
                @update="searchExp"
              >
              </b-form-input>
              <b-overlay :show="spinnerStatus" rounded="sm">
                <b-form-group
                  class="qb-dd-group-sug min-height-adjustment-sugg"
                  v-if="searchexpres.length > 0"
                >
                  <b-form-checkbox
                    class="pointer options"
                    size="sm"
                    v-for="option in searchexpres"
                    :key="option.expertise"
                    :value="option.expertise.toLowerCase()"
                    v-model="aoeoptiontags"
                    name="flavour-4a"
                    :class="{
                      selectedTag: isSelectedaoe(option.expertise),
                      'qb-dropdown-option-sugg': !isSelectedaoe(
                        option.expertise
                      ),
                    }"
                  >
                    {{ option.expertise }}
                  </b-form-checkbox>
                </b-form-group>
                <div
                  v-else-if="
                    searchexpres.length == 0 &&
                    searchexp.length > 0 &&
                    searchexp !== ''
                  "
                  class="mt-2 add-panel-name text-center p-3"
                  size="sm"
                >
                  No matching results for&nbsp;<span class="font-weight-bold"
                    >"{{ searchexp }}"</span
                  >.
                </div>
              </b-overlay>
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- Add Skill Tags -->
      <b-row
        ><b-col>
          <div
            class="topDiv skl-mrgn aoeskl-field panellist-tags"
            ref="skl"
            @click="skillFunction()"
            v-closable="{
              exclude: ['skl', 'skldropdown'],
              handler: 'hideskillOptions',
            }"
          >
            <label class="label-txt-form"
              >Skills<span class="asterik">*</span></label
            >
            <b-form-tags
              remove-on-delete
              @input="skillFunction()"
              :tag-validator="tagValidatorskill"
              invalid-tag-text="Duplicate tag(s)"
              placeholder="Enter skills"
              class="text-truncate filter-input-pan w-100"
              :class="{
                'error reqd_add_1': $v.skilloptionstag.$error,
                reqd_add_2: !$v.skilloptionstag.$error,
                tagsinputField:
                  $v.skilloptionstag.length > 0 && !$v.skilloptionstag.$error,
              }"
              v-model="$v.skilloptionstag.$model"
            ></b-form-tags>
            <div>
              <span class="hint-txt">Press "Enter" to add skills</span>
            </div>

            <!-- Validations for Skills -->
            <div
              v-if="$v.skilloptionstag.$dirty && !$v.skilloptionstag.required"
              class="errortxt position-absolute mt-3"
            >
              Required
            </div>
          </div>
          <!-- Dropdown for Skill Tags-->
          <div
            v-if="skilltag == true"
            class="qb-filter-modal-sug"
            ref="skldropdown"
          >
            <div class="relativeclass aoeinput opt-check">
              <div class="aoesearchicon-pos">
                <img
                  src="../../assets/img/accesscontrol/inputsearch.svg"
                  alt=""
                />
              </div>
              <b-form-input
                class="inputField options"
                type="search"
                placeholder="Search"
                v-model.trim="searchskl"
                debounce="500"
                @update="searchSkl"
              >
              </b-form-input>
              <b-overlay :show="spinnerStatus" rounded="sm">
                <b-form-group
                  class="qb-dd-group-sug min-height-adjustment-sugg"
                  v-if="searchsklres.length > 0"
                >
                  <b-form-checkbox
                    class="pointer options"
                    size="sm"
                    v-for="option in searchsklres"
                    :key="option.skill"
                    name="flavour-4a"
                    :value="option.skill.toLowerCase()"
                    v-model="skilloptionstag"
                    :class="{
                      selectedTag: isSelectedskl(option.skill),
                      ' qb-dropdown-option-sugg': !isSelectedskl(option.skill),
                    }"
                  >
                    {{ option.skill }}
                  </b-form-checkbox>
                </b-form-group>
                <div
                  v-else-if="
                    searchsklres.length == 0 &&
                    searchskl.length > 0 &&
                    searchskl !== ''
                  "
                  class="mt-2 add-panel-name text-center"
                  size="sm"
                >
                  No matching results for&nbsp;<span class="font-weight-bold"
                    >"{{ searchskl }}"</span
                  >.
                </div>
              </b-overlay>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Add Evaluator and Cancel Button -->
    <div class="border-top pt-3 pr-3">
      <div class="d-flex align-items-center justify-content-end">
        <div class="mr-3 cancelpan-btn pointer">
          <b-button style="width: 87px" @click="$emit('cancelPan')"
            >Cancel</b-button
          >
        </div>
        <div class="addpanel pointer">
          <b-button style="width: 90px" class="pl-3 pr-3" @click="addPanel">
            Add
          </b-button>
        </div>
      </div>
    </div>
  </div>
  <!-- </b-overlay> -->
</template>

<script>
import toast from "../../components/mixin/toast";
import { getValidations } from "../../controllers/Panelist/validations";
import {
  searchExp,
  searchSkl,
  addUpdatePanel,
} from "../../controllers/Panelist/asynchronous";
import {
  hideexpertiseoptions,
  convertToLowerCase,
  hideskillOptions,
  tagValidatoraoe,
  tagValidatorskill,
  expertisefunction,
  skillfunction,
} from "../../controllers/Panelist/helpers";
import { NumbersOnly } from "../../controllers/Candidate/helpers";

export default {
  name: "AddPanel",
  data() {
    return {
      // STRING
      searchexp: "",
      searchskl: "",
      searchskill: "",
      SearchExpertise: "",
      temp: "",

      // ARRAY
      searchexpres: [],
      searchsklres: [],
      skill: [],
      area: [],
      aoeoptiontags: [],
      skilloptionstag: [],

      // BOOLEAN
      LoaderStatus: false,
      spinnerStatus: false,
      aoe: false,
      skilltag: false,
      phoneValid: true,

      // OBJECT
      panel: {
        aoearray: [],
        panelID: "",
        skillarray: [],
        name: "",
        email: "",
        phoneNumber: "",
      },
      aoetags: {
        expertise: [],
      },
      skillstags: {
        skill: [],
      },
    };
  },
  mixins: [toast],
  validations() {
    return getValidations(this);
  },
  created() {
    this.searchSkl();
    this.searchExp();
  },

  methods: {
    isSelectedaoe(exp) {
      return this.aoeoptiontags.includes(exp);
    },
    isSelectedskl(skill) {
      return this.skilloptionstag.includes(skill);
    },
    searchExp() {
      searchExp(this);
    },
    searchSkl() {
      searchSkl(this);
    },
    addPanel() {
      addUpdatePanel(this, "fromAdd");
    },

    convertToLowerCase(event) {
      convertToLowerCase(event, this);
    },
    tagValidatoraoe(tag) {
      return tagValidatoraoe(this, tag);
    },
    tagValidatorskill(tag) {
      return tagValidatorskill(this, tag);
    },
    hideskillOptions() {
      hideskillOptions(this);
    },
    hideexpertiseoptions() {
      hideexpertiseoptions(this);
    },
    expertiseFunction() {
      expertisefunction(this);
    },
    skillFunction() {
      skillfunction(this);
    },
    NumbersOnly(evt) {
      NumbersOnly(evt);
    },
    handleCheckboxChange(tag) {
      this.tagValidatorskill(tag);
    },
  },
};
</script>
<style>
.b-form-tags.focus {
  box-shadow: none;
}

/* button.close {
  padding: 0;
  background-color: transparent;
  border: 1px solid #20639b;
  border-radius: 30px;
} */

#searchres {
  visibility: hidden;
}
.close {
  opacity: unset;
}

.qb-dropdown-diffy {
  background: #ffffff;
  border: 1px solid #ced4da;
  box-sizing: border-box;
  border-radius: 3px;
  color: #959494;
  font-size: var(--size-13);
  padding: 12px;
}

.ac-inputField .text-muted {
  color: red !important;
}

.validationicon {
  position: absolute;
  top: 29px;
  right: 10px;
  background: var(--bg-white);
}

.reqd_add_2 .reqd_add_1 .b-form-tags-list .btn {
  display: none;
}
.panellist-tags .text-muted {
  color: red !important;
}
</style>
